import { FirestoreService } from '../../../sdk/firestoreService';

// ============================================
// Action Creators - App Catalog
// ============================================

export const fetchAppCatalogStart = () => ({
    type: 'FETCH_APP_CATALOG_START'
});

export const fetchAppCatalogSuccess = (catalog) => ({
    type: 'FETCH_APP_CATALOG_SUCCESS',
    payload: catalog
});

export const fetchAppCatalogFailure = (error) => ({
    type: 'FETCH_APP_CATALOG_FAILURE',
    payload: error
});

// ============================================
// Action Creators - Predefined Templates
// ============================================

export const fetchPredefinedTemplatesStart = () => ({
    type: 'FETCH_PREDEFINED_TEMPLATES_START'
});

export const fetchPredefinedTemplatesSuccess = (templates) => ({
    type: 'FETCH_PREDEFINED_TEMPLATES_SUCCESS',
    payload: templates
});

export const fetchPredefinedTemplatesFailure = (error) => ({
    type: 'FETCH_PREDEFINED_TEMPLATES_FAILURE',
    payload: error
});

// ============================================
// Action Creators - Dashboards
// ============================================

export const fetchDashboardsStart = () => ({
    type: 'FETCH_DASHBOARDS_START'
});

export const fetchDashboardsSuccess = (dashboards) => ({
    type: 'FETCH_DASHBOARDS_SUCCESS',
    payload: dashboards
});

export const fetchDashboardsFailure = (error) => ({
    type: 'FETCH_DASHBOARDS_FAILURE',
    payload: error
});

// ============================================
// Thunk Actions - App Catalog
// ============================================

/**
 * fetchAppCatalog - טעינת קטלוג האפליקציות
 * משמש בזמן אתחול האפליקציה
 */
export const fetchAppCatalog = () => async (dispatch) => {
    dispatch(fetchAppCatalogStart());
    try {
        console.log('📥 Loading APP-CATALOG...');
        const catalog = await FirestoreService.getAppCatalog();
        console.log('✅ Catalog loaded:', catalog.length, 'items');
        dispatch(fetchAppCatalogSuccess(catalog));
        return catalog;
    } catch (error) {
        console.error('❌ Error loading catalog:', error);
        dispatch(fetchAppCatalogFailure(error.message));
        throw error;
    }
};

// ============================================
// Thunk Actions - Predefined Templates
// ============================================

/**
 * fetchPredefinedTemplates - טעינת תבניות מוכנות מראש
 * משמש בזמן אתחול האפליקציה
 */
export const fetchPredefinedTemplates = () => async (dispatch) => {
    dispatch(fetchPredefinedTemplatesStart());
    try {
        console.log('📥 Loading predefined templates...');
        const templates = await FirestoreService.getPredefinedTemplates();
        console.log('✅ Predefined templates loaded:', templates.length, 'templates');
        dispatch(fetchPredefinedTemplatesSuccess(templates));
        return templates;
    } catch (error) {
        console.error('❌ Error loading predefined templates:', error);
        dispatch(fetchPredefinedTemplatesFailure(error.message));
        throw error;
    }
};

// ============================================
// Thunk Actions - Dashboards
// ============================================

/**
 * fetchDashboards - טעינת כל הדשבורדים של ארגון
 * משמש לצורך "הרכיבים שלי" - כל הווידג'טים מכל הדשבורדים
 */
export const fetchDashboards = (organizationId) => async (dispatch) => {
    console.log('🔄 fetchDashboards - Starting...', { organizationId });
    dispatch(fetchDashboardsStart());
    try {
        const dashboards = await FirestoreService.getDashboardsByOrganization(organizationId);
        console.log('✅ fetchDashboards - Success:', {
            dashboardsCount: dashboards?.length || 0,
            dashboards: dashboards?.map(d => ({
                dashboardId: d.dashboardId,
                name: d.name,
                widgetsCount: d.current?.widgets?.length || 0
            }))
        });
        dispatch(fetchDashboardsSuccess(dashboards));
    } catch (error) {
        console.error('❌ fetchDashboards - Error:', error);
        dispatch(fetchDashboardsFailure('שגיאה בטעינת הדשבורדים'));
    }
};

// ============================================
// Thunk Actions - Initialize App Data
// ============================================

/**
 * initializeAppData - טעינת כל הנתונים הגלובליים של האפליקציה
 * משמש בזמן אתחול האפליקציה (App.js)
 */
export const initializeAppData = () => async (dispatch) => {
    try {
        console.log('🚀 Initializing app data...');
        await Promise.all([
            dispatch(fetchAppCatalog()),
            dispatch(fetchPredefinedTemplates())
        ]);
        console.log('✅ App data initialized successfully');
    } catch (error) {
        console.error('❌ Error initializing app data:', error);
        throw error;
    }
};
